"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSpinner = exports.StyledButton = exports.StyledButtonTextContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = require("../../utils/colors");

var _fontSystem = require("../../utils/fontSystem");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n          height: 1rem;\n          width: 1rem;\n          border: 2px solid\n            ", ";\n          border-right-color: transparent;\n          border-radius: 50%;\n          animation: ", " 1s linear infinite;\n          -webkit-animation: ", " 1s linear infinite;\n          margin-right: 1rem;\n        "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  100% {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  cursor: pointer;\n  outline: none;\n  position: relative;\n  overflow: hidden;\n  border: solid 1px transparent;\n  text-align: center;\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n\n  display: ", ";\n  height: ", ";\n\n  & > :nth-child(1) {\n    margin-right: 0.5rem;\n  }\n\n  & svg {\n    width: 1.3rem;\n    height: 1.3rem;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  :after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 5px;\n    height: 5px;\n    background: ", ";\n    opacity: 0;\n    border-radius: 100%;\n    transform: scale(1, 1) translate(-50%);\n    transform-origin: 50% 50%;\n  }\n\n  :focus:not(:active)::after {\n    animation: ", " 1s ease-out;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(0, 0);\n    opacity: 1;\n  }\n  20% {\n    transform: scale(25, 25);\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n    transform: scale(40, 40);\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    :hover {\n      background: ", ";\n    }\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    background: ", ";\n    color: ", ";\n\n    svg {\n      path {\n        fill: ", ";\n      }\n    }\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    background: transparent;\n    font-size: ", ";\n    border-radius: ", ";\n    color: ", ";\n    font-family: ", ";\n    height: auto;\n    width: ", ";\n    min-width: ", ";\n\n    ", "\n    ", ";\n    ", ";\n\n    svg {\n      path {\n        fill: ", ";\n      }\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    padding: 0.7em 2em;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    padding: 0.4em 1.2em;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    padding: 0.15em 0.5em;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
/**
 * The basic style is basically the tertiary type, where the layout is set,
 * the background is transparent, and the positioning is set based on props
 * @param {*} props
 */


var smallStyle = function smallStyle() {
  return (0, _styledComponents.css)(_templateObject());
};

var mediumStyle = function mediumStyle() {
  return (0, _styledComponents.css)(_templateObject2());
};

var largeStyle = function largeStyle() {
  return (0, _styledComponents.css)(_templateObject3());
};

var basicStyle = function basicStyle(props) {
  var theme = props.theme;
  var buttonTheme = theme.button;
  return (0, _styledComponents.css)(_templateObject4(), buttonTheme.fontSize, buttonTheme.border.radius, props.textColor || (0, _colors.normaliseColor)(buttonTheme.textColor, theme), buttonTheme.fontFamily || theme.defaultFontFamily, props.width, props.theme.button.minWidth, largeStyle(), props.margin && "margin: ".concat(props.margin), props.disabled && "opacity: 0.3;", props.color || (0, _colors.normaliseColor)(props.theme.button.mainColor, props.theme));
};

var primaryStyle = function primaryStyle(props) {
  return (0, _styledComponents.css)(_templateObject5(), props.color || (0, _colors.normaliseColor)(props.theme.button.mainColor, props.theme), props.theme.colors.white, props.theme.colors.white);
};

var secondaryStyle = function secondaryStyle(props) {
  return (0, _styledComponents.css)(_templateObject6(), props.color || (0, _colors.normaliseColor)(props.theme.button.mainColor, props.theme));
};

var hoverStyle = function hoverStyle(props) {
  var color = (0, _colors.normaliseColor)(props.theme.button.hoverColor, props.theme);
  var opacity = props.primary ? 1 : 0.15;
  return (0, _styledComponents.css)(_templateObject7(), (0, _colors.getRGBOpacity)(color, opacity));
};

var AnimationRipple = (0, _styledComponents.keyframes)(_templateObject8());
var RippleEffectStyles = (0, _styledComponents.css)(_templateObject9(), function (props) {
  return (0, _colors.getRGBOpacity)(props.theme.colors.primaryFont, 0.15);
}, AnimationRipple);

var StyledButtonTextContainer = _styledComponents.default.div(_templateObject10(), function (props) {
  return props.showLoading ? 'none' : 'flex';
}, function (props) {
  return props.showLoading ? '0px' : '100%';
});

exports.StyledButtonTextContainer = StyledButtonTextContainer;

var StyledButton = _styledComponents.default.button(_templateObject11(), basicStyle, hoverStyle, function (props) {
  return props.primary && primaryStyle(props);
}, function (props) {
  return props.secondary && secondaryStyle(props);
}, function (props) {
  return props.small && smallStyle();
}, function (props) {
  return props.medium && mediumStyle();
}, function (props) {
  return props.large && largeStyle();
}, RippleEffectStyles, function (props) {
  return props.fontStyle && (0, _fontSystem.fontSystemStyles)(props);
});

exports.StyledButton = StyledButton;
var spin = (0, _styledComponents.keyframes)(_templateObject12());

var StyledSpinner = _styledComponents.default.div(_templateObject13(), function (props) {
  return props.showLoading ? (0, _styledComponents.css)(_templateObject14(), props.primary ? props.theme.colors.white : props.color || (0, _colors.normaliseColor)(props.theme.button.mainColor, props.theme), spin, spin) : '';
});

exports.StyledSpinner = StyledSpinner;